<div class="rodape__informatica" *ngIf="tipoRelatorio == '4'">
  <div class="informacoes">
    <p class="rodape__info">Total</p>
  </div>
  <div class="informacoes__final">
    <p class="rodape__info">SUBTOTAL DO MODELO</p>
    <p class="rodape__info">R$ {{ subTotalModeloInformatica }}</p>
  </div>
</div>

<div class="rodape__outros__relatorios" *ngIf="tipoRelatorio !== '4'">
  <div class="informacoes__outros__relatorios">
    <p class="rodape__info">SUBTOTAL DO MODELO</p>
    <p class="rodape__info">P&B: {{ subtotalModeloPb }}</p>
  </div>
  <div class="informacoes__final">
    <p class="rodape__info">COR: {{ subtotalModeloCor }}</p>
  </div>
</div>

<div class="espaco__branco">

</div>
